import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./pages/Home/Home";
import { Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";
import { ReactComponent as Logo } from "./assets/img/icone.svg";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1800);
  }, []);

  return (
    <div className="background-color-screen">
      {isLoading ? (
        <div className="loading-screen">
          <div className="logo-loader">
            <Logo />
          </div>
        </div>
      ) : (
        <>
          <Navbar />
          <Home />
          <Footer />

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            pauseOnHover
            theme="colored"
          />
        </>
      )}
    </div>
  );
}

export default App;
